import styled, { type DefaultTheme } from 'styled-components'

const placeholder = (props: { theme: DefaultTheme }) =>
  props.theme.colors.badge.incomplete.background

export const HeroImagePlaceholderStyled = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  background-color: ${placeholder};
`

/**
 * Two stacked lines with no gap, matching the card's reserved two-line title
 * and excerpt so the column doesn't jump when the release arrives.
 */
export const ReservedLinesStyled = styled.div`
  > * {
    display: block;
  }
`

export const CtaPlaceholderStyled = styled.div`
  height: ${(props) => props.theme.typography.pxToRem(40)};
  width: ${(props) => props.theme.typography.pxToRem(180)};
  margin: 0 auto;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  background-color: ${placeholder};
`

export const RotationPlaceholderStyled = styled.div`
  height: ${(props) => props.theme.typography.pxToRem(8)};
`
